import React, { useEffect, useState, useRef } from 'react';
import { Modal, Button } from 'antd';
import { PDFDocument } from 'pdf-lib';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInvoice, fetchOrder } from '../../features/Voyage/VoyageSlice';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Descriptions } from 'antd';

import icon from "../../assets/icons/voyages/clipboard-text.svg"

import ReportTitle from "../../assets/icons/ReportTitle.svg";
const DownloadOrder = ({ data, isModalOpen, setIsModalOpen, vesselName }) => {
  const { selectedVoyage, order } = useSelector((state) => state.voyage);
  const [downloadUrl, setDownloadUrl] = useState(null);
  const pdfRef = useRef();
  const dispatch = useDispatch();
// console.log(data)
  async function editPDF(existingPdfBytes) {
    const response = await fetch(existingPdfBytes);
    const data = await response.arrayBuffer();
    const pdfDoc = await PDFDocument.load(data);
    const pdf_entries = order;
    const form = pdfDoc.getForm();

    for (let [key, value] of Object.entries(pdf_entries)) {
      try {
        const balanceTextField = form.getTextField(key);
        if (balanceTextField) {
          if (typeof value === 'number') {
            value = value.toFixed(2);
          }
          balanceTextField.setText(value.toString());
        } else {
          console.error(`Text field with name '${key}' not found.`);
        }
      } catch {
        console.error(`Text field with name '${key}' not found.`);
      }
    }

    form.flatten();
    const modifiedPdfBytes = await pdfDoc.save();
    const blob = new Blob([modifiedPdfBytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    setDownloadUrl(url);
  }



  const handleDownload = async () => {
    const pdf = new jsPDF();
    const data = await html2canvas(pdfRef.current);
    const img = data.toDataURL('image/png');
    const imgProperties = pdf.getImageProperties(img);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
    pdf.addImage(img, 'PNG', 0, 0, pdfWidth, pdfHeight);

    const currentDate = new Date();
    const day = currentDate.getDate().toString().padStart(2, '0');
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const year = currentDate.getFullYear();
    const formattedDate = `${day}${month}${year}`;
    const filename = `order-${order?.trade_order_number}.pdf`;

    pdf.save(filename);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const descriptionItems = [
    { label: "Contact Volume Allowances (EUA) (t/CO2)", detail: data?.contract_volume_allowances },
    { label: "Product", detail: data?.product },
    { label: "Delivery Date", detail: data?.delivery_date },
    { label: "Allowance Price", detail: data?.allowance_price },
    { label: "Total Purchase Price", detail: data?.total_purchase_price },
    { label: "Payment Date", detail: data?.payment_date }
  ];

  return (
    <>
      <Modal
        title="Download Order"
        style={{ top: 20 }}
        width={"90%"}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="download" type="primary" onClick={handleDownload}>
            Download
          </Button>,
        ]}
      >
       <div className='pdf-Main-Container'>
       <div className='pdf-Main-Container'>
                    <div id="pdf" ref={pdfRef}>
                        <div className='pdf-icon-div'>
                            <img className='pdf-icon-first' src={ReportTitle} alt="" />
                        </div>
                        <div className='pdf-info-container'>
                            {/* <h1>EMISSIONS VOYAGE STATEMENT</h1> */}
                        <div className='pdf-description-details  order-pdf-gap'>
                              <div className='pdf-description-box'>
                              <div>
                                <p>Azolla Pte Limited</p>
                                <p>1 Kim Seng Promenade</p>
                                <p># 10/11-12 Great World City</p>
                                <p>237944 , Singapore</p>
                              </div>
                              <div className='pdf-description-details-main'>
                                    <div className='pdf-description-details-box pdf-width'>
                                        <p>Trade Order</p>
                                    </div>
                                    <div className='pdf-description-details-box pdf-width'>
                                        <p>{data?.trade_order_number}</p>
                                    </div>
                                    <div className='pdf-description-details-box pdf-width'>
                                        <p>Vessel Name :</p>
                                        <p>{vesselName || '-'}</p>
                                    </div>
                                    <div className='pdf-description-details-box pdf-width'>
                                        <p>Currency:</p>
                                        <p>{data?.currency}</p>
                                    </div>
                                    <div className='pdf-description-details-box pdf-width'>
                                        <p>Category:</p>
                                        <p>{data?.category}</p>
                                    </div>
                              </div>
                              </div>
                            <div className="pdf-table-container order-pdf">
                                <h3>TRADE ORDER for EU Emission Trading Scheme, EU Allowances</h3>
                                <hr />
                                <div className='order-pdf-details'>
                                <p className='order-pdf-title'>Buyer's Nominated Recipient : </p>
                                <p>{data?.buyer_name}</p>
                                </div>
                                <hr />

                                
                                <Descriptions
                                 title=""
                                 column={6}
                                 layout="vertical"
                                 bordered
                                 className='report-pdf-table'
                               >
                                 {descriptionItems.map((item, index) => (
                                   <Descriptions.Item key={index} label={item.label}>
                                     {item.detail}
                                   </Descriptions.Item>
                                 ))}
                               </Descriptions>
                            </div>
                            <div className="pdf-table-container order-pdf-footer">
                              <div className='order-pdf-containers'>
                              <h3>Buyer</h3>
                              <p>Name : {data?.buyer_name}</p>
                              <p>Title : {data?.buyer_title}</p>
                              </div>
                              <div className='order-pdf-containers'>
                              <h3>Azolla Representative</h3>
                              <p>Name : {data?.azolla_representative}</p>
                              <p>Title : {data?.azolla_title}</p>
                              </div>
                            </div>
                        </div>
                        <div className='pdf-description-details'>
                                {/* <div className='pdf-description-details-main'> */}
                                    <div className='pdf-description-footer'>
                                        <p>- This is an auto generated Order.</p>
                                        <p>- This Order holds no commercial value. A commerical Trade Invoice will be issued upon successful execution of the order.</p>
                                    </div>
                                {/* </div> */}
                            </div>
                    </div>
                </div>
        </div>
        </div>
      </Modal>
    </>
  );
};

export default DownloadOrder;
